export { ExpertQuote, type ExpertQuoteProps } from './ExpertQuote';
